module.exports = __webpack_public_path__ + "img/ntnu_logo_white.21a65fbd.png";